import axios from 'axios'

const protocol = process.env.REACT_APP_BACKEND_PROTOCOL
const host = process.env.REACT_APP_BACKEND_HOST
const port = process.env.REACT_APP_BACKEND_PORT

const $api = axios.create({
  baseURL: `${protocol}://${host}:${port}/api/v1`,
})

$api.interceptors.request.use(
  async (req) => {
    if (req.url?.includes('auth')) {
      return req
    }

    const authTokens = localStorage.getItem('auth_token')

    if (authTokens) {
      req.headers = {
        Authorization: `Bearer ${JSON.parse(authTokens).access_token}`,
      }
    } else {
      req.headers = {}
    }

    return req
  },

  (error) => {
    return Promise.reject(error)
  }
)

export default class API {
  static async getPipelineList() {
    return await $api.get('/webhooks/pipeline')
  }

  static async postWebhook(data) {
    return await $api.post(`/webhooks/post`, data)
  }

  static async getWebhooksList(filter = 'all', search = '') {
    return await $api.get(`/webhooks/get?filter=${filter}&search=${search}`)
  }

  static async deleteWebhook(id) {
    return await $api.patch(`/webhooks/delete/${id}`)
  }

  static async changeWebhook(id, data) {
    return await $api.patch(`/webhooks/patch/${id}`, data)
  }

  // static async changeBundleStatus(id, status) {
  //   return await $api.patch(`/bundle/patch/${id}`, { status: !status })
  // }

  // static async postPreset(data) {
  //   return await $api.post(`/preset/post`, data)
  // }

  // static async getPresetList() {
  //   return await $api.get('/preset/get')
  // }

  // static async changePreset(id, data) {
  //   return await $api.patch(`/preset/patch/${id}`, data)
  // }

  // static async getPresetByID(id) {
  //   return await $api.get(`/preset/get/${id}`)
  // }

  // static async deletePresetByID(id) {
  //   return await $api.delete(`/preset/${id}`)
  // }

  // static async getOptPreset() {
  //   return await $api.get('/preset/opt')
  // }
}
